import { createSelector } from '@reduxjs/toolkit';
import { ReferenceTypesListState } from 'ducks/reference-types-list/slices';
import { RootState } from 'store';

const referenceTypesListSlice = (state: RootState) => state.reference_types_list;

export const selectReferenceTypes = createSelector(
  [referenceTypesListSlice],
  (state): ReferenceTypesListState =>
    state.filter((reference) => {
      const { reference_type_id } = reference;
      return reference_type_id === 3 || reference_type_id === 6;
    }),
);
